/**
 * Remplace {var} et {{var}} dans une chaîne traduite.
 * (Les deux formes existent dans le repo.)
 */
export function translateWithVars(template, vars = {}) {
  if (!template || typeof template !== 'string') return template || '';
  return Object.entries(vars).reduce((text, [key, value]) => {
    const str = String(value ?? '');
    // Prefer double braces first, then single — avoid partial mangles.
    return text
      .replace(new RegExp(`\\{\\{${key}\\}\\}`, 'g'), str)
      .replace(new RegExp(`\\{${key}\\}`, 'g'), str);
  }, template);
}
